import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const Placeholder = styled.span`
  background: ${colors.grayE};
  border-radius: 0.25rem;
  margin-bottom: 1rem;
  padding-bottom: 100%;
  width: 100%;
`;
